import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';
import { ServerStore } from '@seedlang/stores';
import autobind from 'autobind-decorator';
import FormWrapper from 'components/authenticate/form_wrapper';
import Button from 'components/button/button';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import RegistrationForm from './registration_form';
import SeedlangOnly from 'utils/seedlang_only';
import WhitelabelOnly from 'utils/whitelabel_only';

const AuthLinkWrapper = styled.div`
  margin: ${props => props.margin};
  width: 100%;
  text-align: center;
  margin-top: 20px;
`;

const TextLink = styled.div`
  cursor: pointer;
  text-decoration: underline;
  margin: ${props => props.margin};
  a {
    color: ${props => props.color};
  }
  color: ${props => props.color};
`;

const TextLinkWrapper = styled.div`
  font-size: 14px;
  color: ${props => props.color};
`;

@observer
class AuthenticateRegister extends React.Component {
  @observable expanded = false;

  get isExpanded() {
    return !this.props.expandEmail || AppUI.expandedEmailRegistrationFields;
  }

  componentDidMount() {
    ServerStore.clearMessages();
  }

  @autobind expandFormFields() {
    AppUI.set('expandedEmailRegistrationFields', true);
  }

  @computed get showForm() {
    return true;
  }

  render() {
    return (
      <FormWrapper
        padding={0}
        background={this.props.background}
        width={this.props.width}
        borderRadius={this.props.borderRadius}
        color={this.props.color}
      >
        {
          !this.showForm &&
            <Button
              onClick={this.expandFormFields}
              scaleOnHover='1.05'
              height='50px'
              borderRadius='50px'
              width='100%'
              background={AppUI.siteIsDefault ? Theme.blue : AppUI.site.accentColor}
              color='#FFF'
              backgroundOnHover='#FFF'
            >
              Create Account
            </Button>
        }
        {
          this.showForm &&
            <RegistrationForm
              checkout={this.props.checkout}
              showEmailConfirmation={this.props.showEmailConfirmation}
              showTerms={this.props.showTerms}
              hidePrivacy={this.props.hidePrivacy}
              hideTitle={this.props.hideTitle}
              hideSpinner={this.props.hideSpinner}
              color={this.props.color}
              levelId={this.props.levelId}
              languageId={this.props.languageId}
              targetLanguageId={this.props.targetLanguageId}
              onCloseModal={this.props.onCloseModal}
              afterRegistration={this.props.afterRegistration}
              onConfirmationRequired={this.props.onConfirmationRequired}
            />
        }

        {
          this.props.contentAfterButton
        }

        {
          this.props.onSigninLinkClick && (
            <AuthLinkWrapper>
              <SeedlangOnly>
                <TextLink
                  onClick={this.props.onSigninLinkClick}
                  color='#FFF'
                >
                  Already have an account?
                </TextLink>
              </SeedlangOnly>
              <WhitelabelOnly>
                <TextLinkWrapper color={AppUI.site?.footerBackgroundColor || '#FFF'}>
                  Member of Seedlang or an Easy Languages site?{' '}
                  <TextLink
                    as='span'
                    onClick={this.props.onSigninLinkClick}
                    color={AppUI.site?.footerBackgroundColor || '#FFF'}
                  >
                    Sign In.
                  </TextLink>
                </TextLinkWrapper>
              </WhitelabelOnly>
            </AuthLinkWrapper>
          )
        }
      </FormWrapper>
    );
  }
}

export default AuthenticateRegister;
